import { startEditPagesResponseSchema } from '../models/editPages.schema';

export const startEditPages = (annotationId: number) => {
  return {
    endpoint: `/annotations/${annotationId}/edit_pages/start`,
    method: 'POST',
    responseSchema: startEditPagesResponseSchema,
  } as const;
};
